// extracted by mini-css-extract-plugin
export var configurationSection = "_rm-0";